<template>
  <div></div>
</template>
<script>
export default {
  mounted() {
    this.checkCookies();
  },
  methods: {
    checkCookies() {
      if (localStorage.getItem("CookieConcent") != "True") {
        this.cookiePopUp();
      }
    },
    cookiePopUp() {
      this.$buefy.dialog.confirm({
        title: "Cookies Policy",
        message: `We use cookies to assist you in navigation and login. We also use cookies to analyze your use of our application. For more information please visit our <a href="https://circul8.world/cookie-policy.html" target="_blank">Cookie Policy</a>`,
        confirmText: "Accept",
        cancelText: "Learn More",
        type: "is-info",
        canCancel: false,
        onConfirm: this.cookieConfirm,
        onCancel: this.learnMore
      });
    },
    cookieConfirm() {
      document.cookie = "CookieConcent=True";
      localStorage.setItem("CookieConcent", "True");
      location.reload();
    }
  }
};
</script>
